import { IConfig } from '@cian/config/shared';
import * as React from 'react';

import { RosreestrCheckedTooltipContent } from '../../../components/RosreestrCheckedTooltipContent';
import { ELabelColor, ILabel } from '../../../types/label';
import { TOfferType } from '../../../types/offer';

type TooltipText = { title: string; description: string };

const DEFAULT_TOOLTIP_TEXT: TooltipText = {
  title: 'Проверено в Росреестре',
  description:
    'в объявлении верно указаны площадь, этаж и другие ключевые параметры\n' +
    'объект находится по указанному адресу\n' +
    'объект можно законно продать или сдать — на него не наложен арест',
};

export function getRosreestrCheckedLabel(offerType: TOfferType, config: IConfig): ILabel {
  const { title, description } = config.get<TooltipText>('moderationRosReestrTooltip.Text') ?? DEFAULT_TOOLTIP_TEXT;

  if (offerType === 'commercial') {
    return { color: ELabelColor.Gray, text: 'Проверено в Росреестре' };
  }

  return {
    text: 'Проверено в Росреестре',
    color: ELabelColor.Gray,
    tooltip: { title, description: <RosreestrCheckedTooltipContent tooltipText={description} /> },
  };
}
